import type { PageViewPayload } from "@generated/model/pageViewPayload";
import { getCsrfToken } from "@utils/csrfUtils";

const isIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch (_) {
    return true;
  }
};

export const handlePageView = async (meta: string | null): Promise<void> => {
  if (meta == null) {
    return;
  }
  const payload: PageViewPayload = {
    meta: meta,
    iframe: isIframe(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

  await fetch("/gaapi/act/pv", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-Token": await getCsrfToken(),
    },
    // eslint-disable-next-line no-restricted-syntax
    body: JSON.stringify(payload),
  });
};
